module.exports = __webpack_public_path__ + "img/man.0257618b.png";